"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingSheet = void 0;
const barcode_1 = require("client/components/barcode");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./billing-sheet.less");
let BillingSheet = class BillingSheet extends react_1.Component {
    constructor(props) {
        super(props);
        this.renderPatientInfo = (inventory, order, patient) => (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Address: "),
                            React.createElement("td", null, [patient.address, patient.address2].join(" ").trim())),
                        React.createElement("tr", null,
                            React.createElement("td", null, "City/State/Zip: "),
                            React.createElement("td", null, `${patient.city} ${patient.state} ${patient.zip}`)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Home Phone: "),
                            React.createElement("td", null, patient.phone)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Cell Phone: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Work Phone: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Dispense Time: "),
                            React.createElement("td", null, moment(order.createDate).format("MM/DD/YY h:mm a"))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Reimbursement: "),
                            React.createElement("td", null))))),
            React.createElement("td", { className: "billing-sheet__divider" }),
            React.createElement("td", { className: "wide" },
                React.createElement("table", { className: "wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Gender: "),
                            React.createElement("td", { className: "wide" }, patient.gender === "1" ? "Male" : "Female")),
                        React.createElement("tr", null,
                            React.createElement("td", null, "SSN: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "DOB: "),
                            React.createElement("td", null, moment(patient.birthDate).format("MM/DD/YYYY"))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Claim #: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Injury: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Approved: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Group: "),
                            React.createElement("td", null))))),
            React.createElement("td", null),
            React.createElement("td", { className: "center" },
                React.createElement(barcode_1.UiBarcode, { background: "transparent", displayValue: true, height: 80, lineColor: "#26324e", value: inventory.barCode, margin: 0, width: 1 }),
                React.createElement("br", null),
                moment().format("ddd MM/DD/YY h:mm:ss A"),
                React.createElement("br", null),
                store_2.usersStore.user.value &&
                    `${store_2.usersStore.user.value.firstName} ${store_2.usersStore.user.value.lastName}`)));
        this.renderSiteInfo = (order, provider, orderSite) => (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Site #: "),
                            React.createElement("td", null, orderSite.ncpdpId)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Name: "),
                            React.createElement("td", null, orderSite.name)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Address: "),
                            React.createElement("td", null, orderSite.address)),
                        React.createElement("tr", null,
                            React.createElement("td", null),
                            React.createElement("td", null, `${orderSite.city} ${orderSite.state} ${orderSite.zip}`)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Phone: "),
                            React.createElement("td", null, orderSite.phone)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Fax: "),
                            React.createElement("td", null, orderSite.fax)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "User: "),
                            React.createElement("td", null, order.user))))),
            React.createElement("td", { className: "billing-sheet__divider" }),
            React.createElement("td", null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Doc: "),
                            React.createElement("td", null, `${provider.lastName}, ${provider.firstName} ${provider.title} (${orderSite.city} ${orderSite.state}) ${provider.npiNumber}`)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "DEA #: "),
                            React.createElement("td", null, provider.dea)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "State Lic#: "),
                            React.createElement("td", null, provider.stateLicense)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Tax ID: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "NPI: "),
                            React.createElement("td", null, provider.npiNumber)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Active Prov #: "),
                            React.createElement("td", null))))),
            React.createElement("td", { className: "billing-sheet__divider" })));
        this.renderPayerInfo = () => (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Payer: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Address: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Phone: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Is Dept of Labor: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Adjuster: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Verified: "),
                            React.createElement("td", null))))),
            React.createElement("td", { className: "billing-sheet__divider" }),
            React.createElement("td", null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Employer: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Address: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Phone: "),
                            React.createElement("td", null))))),
            React.createElement("td", { className: "billing-sheet__divider" }),
            React.createElement("td", null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Attorney: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Practice: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Address: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Phone: "),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Fax: "),
                            React.createElement("td", null)))))));
        this.renderOrder = (claims) => (React.createElement("tr", null,
            React.createElement("td", { className: "top wide", colSpan: 5 },
                React.createElement("table", { className: "wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("th", { className: "border" }, "Rx #"),
                            React.createElement("th", { className: "border" }, "ICD10"),
                            React.createElement("th", { className: "border" }, "NDC"),
                            React.createElement("th", { className: "border" }, "Ref NDC"),
                            React.createElement("th", { className: "border" }, "B"),
                            React.createElement("th", { className: "border" }, "Name"),
                            React.createElement("th", { className: "border" }, "Form"),
                            React.createElement("th", { className: "border" }, "Lot"),
                            React.createElement("th", { className: "border" }, "AWP"),
                            React.createElement("th", { className: "border" }, "MAC"),
                            React.createElement("th", { className: "border" }, "Reim"),
                            React.createElement("th", { className: "border" }, "Status")),
                        claims.map((claim, index) => {
                            const inventory = claim.inventory;
                            return (React.createElement("tr", { key: index },
                                React.createElement("td", { className: "border" }, claim.id),
                                React.createElement("td", { className: "border" }, inventory.typeICD10s),
                                React.createElement("td", { className: "border" }, inventory.package),
                                React.createElement("td", { className: "border" }, ""),
                                React.createElement("td", { className: "border" }, ""),
                                React.createElement("td", { className: "border" }, inventory.name),
                                React.createElement("td", { className: "border" }, `${inventory.strength} ${inventory.unit}`),
                                React.createElement("td", { className: "border" }, claim.lotNum),
                                React.createElement("td", { className: "border right" }, inventory.priceAWP),
                                React.createElement("td", { className: "border right" }, ""),
                                React.createElement("td", { className: "border right" }, index === 0 || claims[index - 1].id !== claim.id
                                    ? (claim.totalAmount / 100).toFixed(2)
                                    : ""),
                                React.createElement("td", { className: "border right" }, "")));
                        }))))));
        this.renderDivider = () => (React.createElement("tr", null,
            React.createElement("td", { className: "billing-sheet__horizontal-divider", colSpan: 5 })));
    }
    render() {
        const claim = store_1.ordersStore.claim.value;
        const inventory = claim && claim.inventory;
        const patient = claim && claim.order.patient;
        const provider = claim && claim.order.provider;
        const orderSite = claim && claim.order.site;
        const status = claim && claim.status;
        const claims = store_1.ordersStore.claimsGroup.value &&
            store_1.ordersStore.claimsGroup.value
                .reduce((a, c) => a.concat(...c.children), [])
                .map(item => {
                const arry = [];
                while (arry.length < item.quantity) {
                    arry.push(item);
                }
                return arry;
            })
                .reduce((a, c) => a.concat(...c), [])
                .filter(claim => claim.status === status);
        return (React.createElement("div", { className: "billing-sheet" },
            React.createElement("div", { className: "billing-sheet__container" },
                React.createElement("table", { className: "wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 5 },
                                React.createElement("span", { className: "billing-sheet__name" }, patient && `${patient.lastName}, ${patient.firstName}`))),
                        claim &&
                            claim.order &&
                            inventory &&
                            patient &&
                            this.renderPatientInfo(inventory, claim.order, patient),
                        this.renderDivider(),
                        claim &&
                            provider &&
                            orderSite &&
                            this.renderSiteInfo(claim.order, provider, orderSite),
                        this.renderDivider(),
                        this.renderPayerInfo(),
                        this.renderDivider(),
                        claims && this.renderOrder(claims),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 5, className: "center small" },
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "NOTICE: Page contains private patient information and should be handled in accordance with",
                                React.createElement("br", null),
                                "HIPAA guidelines to protect the privacy of the patient.")))))));
    }
};
BillingSheet = __decorate([
    mobx_react_1.observer
], BillingSheet);
exports.BillingSheet = BillingSheet;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/billing-sheet/billing-sheet.tsx
// module id = 3724
// module chunks = 0